import styled from 'styled-components'
import { Link as RouterLink } from 'react-router-dom'

import { Colors } from 'cio-design-library/design-tokens'
import { Icon24, Icon20 } from 'builder/components/Icon'
import Drawer from 'builder/components/Drawer/Drawer'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Logo } from 'builder/components/Logo'

export const Container = styled.div`
  background-color: ${Colors.White};
  position: sticky;
  height: 100vh;
  top: 0;
  bottom: 0;
  z-index: 600;
  display: flex;

  ${Media.Tablet`
    position: fixed;
    align-items: center;
  `}

  ${Media.Phone`
    display: none;
  `};
`

export const LeftDrawer = styled(Drawer)`
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 32px;
  height: 100%;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  &:hover {
    border-right: 1px solid ${Colors.Neutral15};
  }

  ${Container}:hover & {
    border-right: 1px solid ${Colors.Neutral15};
  }
`

export const SubMenuIcon = styled(Icon20.ChevronDown)`
  transform: rotate(-90deg);

  path {
    fill: ${Colors.Neutral50};
  }
`

export const Label = styled.div`
  padding: 2px 3px;
  border-radius: 4px;
  background: ${Colors.Blue50};
  color: ${Colors.White};
  ${Typography.Tiny};
  ${FontWeights.DemiBold};
`

export const Badge = styled.div`
  padding: 2px 6px;
  border-radius: 34px;
  background: ${Colors.Blue50};
  color: ${Colors.White};
  ${Typography.Tiny};
  ${FontWeights.DemiBold};
`

export const ExternalIcon = styled(Icon20.ArrowLeft)`
  transform: rotate(135deg);
`

export const CloseButton = styled.button`
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0;
  height: 32px;
  width: 32px;
  border-radius: 50% 50%;
  padding: 1px;
  background-color: ${Colors.Neutral10};
  color: ${Colors.Neutral70};
  border: none !important;
  cursor: pointer;

  &:hover {
    background: ${Colors.Blue10}!important;
    color: ${Colors.Blue50};
  }

  ${Media.Tablet` opacity: 1; `}

  ${Container}:hover & {
    opacity: 1;
  }
`

export const CloseIcon = styled(Icon24.ChevronLeftCurrentColor)`
  ${CloseButton}:hover {
    fill: ${Colors.Blue50}!important;
    color: ${Colors.Blue50}!important;
  }
`

export const OpenIcon = styled(Icon24.ChevronRight)`
  ${CloseButton}:hover {
    fill: ${Colors.Blue50}!important;
    color: ${Colors.Blue50}!important;
  }
`

export const LogoLink = styled(RouterLink).withConfig({
  shouldForwardProp: propName => ['isMenuOpen'].includes(propName) === false,
})<{ isMenuOpen: boolean }>`
  display: flex;
  transition: opacity 0.2s, visibility 0.2s;
  opacity: ${props => (props.isMenuOpen ? 0 : 1)};
  visibility: ${props => (props.isMenuOpen ? 'hidden' : 'visible')};

  ${Media.Phone`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  `}
`

export const LogoStyled = styled(Logo)`
  width: 133px;
  height: 40px;
`

export const LogoContainer = styled.div`
  margin: 0 8px 24px 8px;
`
